var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioManagement01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Audio Management-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.38,3.15a10.37,10.37,0,0,1,3.53,6,7.83,7.83,0,0,1,.16,1.17.42.42,0,0,0,0,.15v1.36l-.12.84a10.16,10.16,0,0,1-1.54,4.12,10.31,10.31,0,0,1-2.09,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.54,5.4A7.55,7.55,0,0,1,20,9.59a7.37,7.37,0,0,1,.16,1.56,7.51,7.51,0,0,1-2.64,5.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.7,7.65a4.63,4.63,0,0,1,0,7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.55,
    y: 6.27,
    width: 3.33,
    height: 9.77
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.09 6.23 11.79 1 11.79 21.31 4.87 15.91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioManagement01);
export default __webpack_public_path__ + "static/media/Audio_Management_01.00b72f63a03805ec478f6034fb1ad3bc.svg";
export { ForwardRef as ReactComponent };